import { sectionNames } from "./config.js";
export { sectionNames };
import { homeContent } from "./content/home.js";
import { javascriptContent } from "./content/javascript.js";
import { exercisesContent } from "./content/js-exercises.js";
import { gitContent } from "./content/git.js";
import { parseTopics } from "./menuStructureParser.js";

const sectionContentByName = {
  home: homeContent,
  javascript: javascriptContent,
  exercises: exercisesContent,
  git: gitContent,
};

let cachedMenuStructure = null;

export const fetchSectionContent = (sectionName) => {
  const content = sectionContentByName[sectionName.toLowerCase()];
  if (content) {
    return content;
  }
  console.error(`No content found for section "${sectionName}"`);
  return "";
};

const buildMenuStructure = () => {
  const sections = [];
  sectionNames.forEach((sectionName) => {
    const content = fetchSectionContent(sectionName);
    sections.push({
      name: sectionName,
      children: parseTopics(sectionName, content),
    });
  });
  return sections;
};

export const getMenuStructure = () => {
  if (cachedMenuStructure === null) {
    cachedMenuStructure = buildMenuStructure();
  }
  return cachedMenuStructure;
};

export const findSectionByName = (sectionName) => {
  const section = getMenuStructure().find((item) => item.name === sectionName);
  return section;
};

export const getSectionNameFromDataId = (dataId) => {
  const [sectionName] = dataId.split("-");
  return sectionName;
};
